<template>
    <rkm-modal persistent ref="modal" title="Autorização do supervisor">
        <rkm-form ref="form" show-legend>
            <rkm-row>
                <rkm-col>
                    <rkm-form-input :validations="{required: true}" label="Usuário" v-model="model.usuario" />
                </rkm-col>
            </rkm-row>
            <rkm-row>
                <rkm-col>
                    <rkm-form-input :validations="{required: true}" label="Senha" type="password" v-model="model.senha" />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button :disabled="submitting" @click="$refs.modal.hide()">Cancelar</rkm-button>
            <rkm-button :disabled="submitting" @click="authorize" color="primary">Autorizar e reagendar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({model: {usuario: null, senha: null}}),
    methods: {
        open() {
            this.model = {usuario: null, senha: null}
            this.$refs.modal.show()
            this.$nextTick(() => this.$refs.form.resetValidator())
        },
        close() {
            this.$refs.modal.hide()
        },
        authorize() {
            this.$refs.form.validate().then(valid => {
                if (!valid) return
                this.$emit('authorized', {...this.model})
            })
        },
    },
    props: {submitting: {type: Boolean, default: false}},
}
</script>
